import validator from 'validator';
import { healthVideosPageData as pageData } from '../utils/pageContent';

function AddEditGuidanceValidation(
  data,
  focusList,
  selectedFile,
  selectedGuidance,
  expertId,
  isDraft
) {
  const errors = {};
  const validationMessages = pageData.addEditHealthVideosPageData.validationMessages;

  if (validator.isEmpty(data?.guidanceTitle?.trim()))
    errors.guidanceTitle = validationMessages.enterNameErrorMessage;
  if (!isDraft && validator.isEmpty(data?.description?.trim()))
    errors.description = validationMessages.enterDescriptionErrorMessage;
  if (validator.isEmpty(data?.video_iframe?.trim()))
    errors.video_iframe = validationMessages.enterVideoIdErrorMessage;
  if (focusList?.length === 0 && !data?.guidanceId)
    errors.focus = validationMessages.selectCategoryErrorMessage;
  if (!selectedFile && selectedFile === '' && selectedFile !== File)
    errors.guidanceFile = validationMessages.selectFileErrorMessage;
  if (!selectedGuidance && selectedGuidance === '' && selectedGuidance !== File)
    errors.guidanceImage = validationMessages.selectThumbnailErrorMessage;
  if (!isDraft && !expertId?.id) errors.expertId = validationMessages.selectExpertErrorMessage;
  if (selectedGuidance && data?.video_iframe) {
    delete errors.guidanceFile;
  }
  if (selectedFile) {
    delete errors.guidanceImage;
    delete errors.video_iframe;
  }
  return { errors, isValid: Object.keys(errors).length <= 0 };
}

function AddEditGuidanceDetailsValidation(data, focusList, expertId, isDraft) {
  const errors = {};
  const validationMessages = pageData.addEditHealthVideosPageData.validationMessages;

  if (validator.isEmpty(data?.guidanceTitle?.trim()))
    errors.guidanceTitle = validationMessages.enterNameErrorMessage;
  if (!isDraft && validator.isEmpty(data?.description?.trim()))
    errors.description = validationMessages.enterDescriptionErrorMessage;
  if (focusList?.length === 0 && !data?.guidanceId)
    errors.focus = validationMessages.selectCategoryErrorMessage;
  if (!isDraft && !expertId?.id) errors.expertId = validationMessages.selectExpertErrorMessage;
  return { errors, isValid: Object.keys(errors).length <= 0 };
}

function AddEditGuidanceContentValidation(data, selectedGuidance, selectVideoType, selectedFile) {
  const errors = {};
  const validationMessages = pageData.addEditHealthVideosPageData.validationMessages;

  if (!selectVideoType || !selectVideoType.value) {
    errors.videoType = validationMessages.selectVideoTypeErrorMessage;
  } else if (selectVideoType.value === 2) {
    if (!selectedFile && selectedFile === '' && selectedFile !== File)
      errors.guidanceFile = validationMessages.selectFileErrorMessage;
  } else if (selectVideoType.value === 1 && validator.isEmpty(data?.video_iframe?.trim())) {
    errors.video_iframe = validationMessages.enterVideoIdErrorMessage;
    if (selectedGuidance && data?.video_iframe) {
      delete errors.guidanceFile;
    }
  }

  if (!selectedGuidance && selectedGuidance === '' && selectedGuidance !== File)
    errors.guidanceImage = validationMessages.selectThumbnailErrorMessage;

  if (selectedFile) {
    delete errors.video_iframe;
  }
  return { errors, isValid: Object.keys(errors).length <= 0 };
}

function AddEditGuidanceAudienceValidation(
  data,
  focusList,
  selectVideoType,
  selectedFile,
  selectedGuidance,
  expertId,
  selectedAudience,
  isDraft
) {
  const errors = {};
  const validationMessages = pageData.addEditHealthVideosPageData.validationMessages;

  if (validator.isEmpty(data?.guidanceTitle?.trim()))
    errors.guidanceTitle = validationMessages.enterNameErrorMessage;
  if (!isDraft && validator.isEmpty(data?.description?.trim()))
    errors.description = validationMessages.enterDescriptionErrorMessage;
  if (focusList?.length === 0 && !data?.guidanceId)
    errors.focus = validationMessages.selectCategoryErrorMessage;
  if (!isDraft && !expertId?.id) errors.expertId = validationMessages.selectExpertErrorMessage;

  if (!selectVideoType || !selectVideoType.value) {
    errors.videoType = validationMessages.selectVideoTypeErrorMessage;
  } else if (selectVideoType.value === 2) {
    if (!selectedFile && selectedFile === '' && selectedFile !== File)
      errors.guidanceFile = validationMessages.selectFileErrorMessage;
  } else if (selectVideoType.value === 1 && validator.isEmpty(data?.video_iframe?.trim())) {
    errors.video_iframe = validationMessages.enterVideoIdErrorMessage;
    if (selectedGuidance && data?.video_iframe) {
      delete errors.guidanceFile;
    }
  }

  if (
    !selectedAudience ||
    selectedAudience.value === undefined ||
    selectedAudience.value === null
  ) {
    errors.audience = validationMessages.selectAudienceErrorMessage;
  }

  if (!selectedGuidance && selectedGuidance === '' && selectedGuidance !== File)
    errors.guidanceImage = validationMessages.selectThumbnailErrorMessage;

  if (selectedFile) {
    delete errors.video_iframe;
  }

  return { errors, isValid: Object.keys(errors).length <= 0 };
}

export {
  AddEditGuidanceValidation,
  AddEditGuidanceDetailsValidation,
  AddEditGuidanceContentValidation,
  AddEditGuidanceAudienceValidation
};
